// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lShlQz","wrapper--mobile":"_2JoxWX","title":"qZdQlT","message":"_3Z_abQ","contact":"_2dDiFJ"};